import { pbxSettingsEn } from './en'

export const pbxSettingsEnUs = pbxSettingsEn
